var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBiometric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Biometric",
    transform: "translate(3711 -5635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    transform: "translate(-3711 5635)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "fingerprint_2_",
    "data-name": "fingerprint (2)",
    transform: "translate(-3705 5641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M40.321,0A40.321,40.321,0,1,0,80.642,40.321,40.3,40.3,0,0,0,40.321,0Z",
    fill: "#4b5add"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M256,0V80.642A40.321,40.321,0,0,0,256,0Z",
    transform: "translate(-215.679)",
    fill: "#4b5add"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    transform: "translate(10.026 9.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M103.881,271.966a2.363,2.363,0,0,0-4.041-2.449c-2.469,4.074-6.4,8.238-10.719,9.845a2.363,2.363,0,1,0,1.647,4.429C96.152,281.789,100.85,276.967,103.881,271.966Z",
    transform: "translate(-83.812 -235.476)",
    fill: "#e1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M184.4,187.715a2.363,2.363,0,0,0,4.512,1.4c2.64-8.477,16.164-5.563,13.406,4.655-1.9,7.046-7.874,16.321-15.216,23.628a2.363,2.363,0,1,0,3.333,3.349c7.887-7.85,14.341-17.956,16.444-25.745,1.418-5.253-.213-8.873-1.83-10.985A11.825,11.825,0,0,0,184.4,187.715Z",
    transform: "translate(-165.291 -160.53)",
    fill: "#e1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M118.416,71.48a30.763,30.763,0,0,0-49.176.559c-2.828,3.868-4.215,8.57-5.352,10.926a2.363,2.363,0,1,0,4.256,2.053C70.228,80.7,71.236,74.654,78.694,69.2c18.041-13.191,44.45,1.051,40.859,25.242a2.363,2.363,0,0,0,4.674.694A30.423,30.423,0,0,0,118.416,71.48Z",
    transform: "translate(-63.653 -59.481)",
    fill: "#e1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M286.106,387.663a2.362,2.362,0,0,0-3.27.685c-1.022,1.564-2.086,3.126-3.251,4.774a2.363,2.363,0,1,0,3.858,2.728c1.2-1.7,2.294-3.3,3.349-4.917A2.363,2.363,0,0,0,286.106,387.663Z",
    transform: "translate(-245.207 -335.648)",
    fill: "#e1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M310.4,138.969a2.362,2.362,0,0,0-2.561,3.971,16.321,16.321,0,0,1,7.457,14.585,2.363,2.363,0,0,0,4.721.2A21,21,0,0,0,310.4,138.969Z",
    transform: "translate(-268.47 -126.131)",
    fill: "#e1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M211.5,124.744a16.568,16.568,0,0,1,6.875-.477,2.363,2.363,0,0,0,.661-4.679,21.3,21.3,0,0,0-8.837.613,2.362,2.362,0,1,0,1.3,4.542Z",
    transform: "translate(-185.671 -109.945)",
    fill: "#e1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M79.262,160.053a16.453,16.453,0,0,1,5.016-7.638,2.362,2.362,0,1,0-3.073-3.589,21.17,21.17,0,0,0-6.456,9.828c-1.823,5.881-4.541,9.375-8.308,10.683a2.363,2.363,0,0,0,1.55,4.464C73.2,171.991,77,167.365,79.262,160.053Z",
    transform: "translate(-64.664 -134.275)",
    fill: "#e1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M151.886,242.46a2.363,2.363,0,0,0-4.511-1.406,37.132,37.132,0,0,1-16.528,21.377,2.363,2.363,0,1,0,2.307,4.124C141.055,262.135,148.4,253.631,151.886,242.46Z",
    transform: "translate(-119.245 -211.057)",
    fill: "#e1e4f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(40.321 9.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M262.73,193.748A46.583,46.583,0,0,1,256,207.206v7.831c5.459-6.666,9.671-14.05,11.292-20.058,2.473-9.162-4.142-15.638-11.292-15.59v4.725C260.122,184.065,264.371,187.669,262.73,193.748Z",
    transform: "translate(-256 -160.488)",
    fill: "#e1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M256,59.384V64.11c14.794-.039,28.221,12.625,25.6,30.253a2.363,2.363,0,0,0,4.674.694C289.3,74.688,273.8,59.337,256,59.384Z",
    transform: "translate(-256 -59.384)",
    fill: "#e1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M286.106,387.663a2.362,2.362,0,0,0-3.27.685c-1.022,1.564-2.086,3.126-3.251,4.774a2.363,2.363,0,1,0,3.858,2.728c1.2-1.7,2.294-3.3,3.349-4.917A2.363,2.363,0,0,0,286.106,387.663Z",
    transform: "translate(-275.502 -335.633)",
    fill: "#e1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M310.4,138.969a2.362,2.362,0,0,0-2.561,3.971,16.321,16.321,0,0,1,7.457,14.585,2.363,2.363,0,0,0,4.721.2A21,21,0,0,0,310.4,138.969Z",
    transform: "translate(-298.765 -126.116)",
    fill: "#e1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M258.405,124.274a2.363,2.363,0,1,0,.661-4.679,21.141,21.141,0,0,0-3.065-.208v4.725A16.406,16.406,0,0,1,258.405,124.274Z",
    transform: "translate(-256.001 -109.937)",
    fill: "#e1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M256,239.412v9.079a45.991,45.991,0,0,0,2.346-6.018A2.361,2.361,0,0,0,256,239.412Z",
    transform: "translate(-256 -211.056)",
    fill: "#e1e4f9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M335.772,261.531V251.443a4.718,4.718,0,0,1,9.435,0v2.291a2.363,2.363,0,1,0,4.725,0v-2.291a9.443,9.443,0,0,0-18.886,0v10.088Z",
    transform: "translate(-278.906 -203.884)",
    fill: "#3c3a41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M391,242v4.725a4.723,4.723,0,0,1,4.718,4.718v2.291a2.363,2.363,0,0,0,4.725,0v-2.291A9.454,9.454,0,0,0,391,242Z",
    transform: "translate(-329.416 -203.884)",
    fill: "#2b292c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M326.988,384.626H303.363A2.363,2.363,0,0,1,301,382.263v-18.9A2.363,2.363,0,0,1,303.363,361h23.626a2.363,2.363,0,0,1,2.363,2.363v18.9A2.363,2.363,0,0,1,326.988,384.626Z",
    transform: "translate(-253.591 -304.141)",
    fill: "#fd9a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M402.813,361H391v23.626h11.813a2.363,2.363,0,0,0,2.363-2.363v-18.9A2.363,2.363,0,0,0,402.813,361Z",
    transform: "translate(-329.416 -304.141)",
    fill: "#fd9a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M368.088,425.725h-4.725a2.363,2.363,0,0,1,0-4.725h4.725a2.363,2.363,0,1,1,0,4.725Z",
    transform: "translate(-304.141 -354.691)",
    fill: "#f0725f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M393.363,421H391v4.725h2.363a2.363,2.363,0,1,0,0-4.725Z",
    transform: "translate(-329.416 -354.691)",
    fill: "#ea3d2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M256,209.388v4.73a2.361,2.361,0,0,1,2.346,3.062A45.94,45.94,0,0,1,256,223.2v9.282a46.575,46.575,0,0,0,6.73-13.458C264.362,212.976,260.151,209.339,256,209.388Z",
    transform: "translate(-215.679 -176.408)",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiometric);
export default __webpack_public_path__ + "static/media/Biometric.b9aace8f69d07c3c3a17a411811b75dd.svg";
export { ForwardRef as ReactComponent };